import Page from "@/lib/pages/Page";
import NavButton from "@/lib/components/NavButton";

export default function Index() {
    return (
        <Page scrollable={true}>
            <NavButton href={`/u/docs/howto`} title={"Bruksanvisning"}/>
            <NavButton href={`/u/docs/rules`} title={"Retningslinjer"}/>
            <NavButton href={`/u/docs/cookie-policy`} title={"Informasjonskapsler"}/>
            <NavButton href={`/u/docs/privacy-policy`} title={"Personvernsvilkår"}/>
            <NavButton href={`/u/docs/about`} title={"Om oss"}/>
            <NavButton href={`/u/version`} title={"Versjon"}/>
        </Page>
    )
}